import React, { useState } from 'react'

// bootstrap
import { Modal } from 'react-bootstrap';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// helpers
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions';

// modals
import EditVariantImageModal from './Modals/EditVariantImageModal';
import EditVariantMoreDetailsModal from './Modals/EditVariantMoreDetailsModal';


export default function VariationsMain(props) {
    // props
    const {
        formik,

        productCombinations,
        setProductCombinations,
        productCombinationsImages,

        disabledVariantList,
        setDisabledVariantList
    } = props

    // states
    const [editVariantMoreDetailsVisibility, setEditVariantMoreDetailsVisibility] = useState(false)

    const [variantSelectedId, setVariantSelectedId] = useState("")
    const [variantSelectedItemForMoreDetails, setVariantSelectedItemForMoreDetails] = useState("")

    const [variantSelectedToBeEdit, setVariantSelectedToBeEdit] = useState([])
    const [editVariantImgModalVisibility, setEditVariantImgModalVisibility] = useState(false)


    // when variant status changes
    const handleVariantEnableChange = debounce((ev, id) => {
        let inpValue = ev.target

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]
        let newCombinationArray;

        // if checked
        if (inpValue.checked) {
            // generating values
            newCombinationArray = COPY_productCombinations.map(item => {
                if (item.id === id) {
                    // returning array with changed values
                    return {
                        ...item,
                        status: 1, // changing value
                    }
                }
                return item
            })
        } else {
            // generating values
            newCombinationArray = COPY_productCombinations.map(item => {
                if (item.id === id) {
                    // returning array with changed values
                    return {
                        ...item,
                        status: 0, // changing value
                    }
                }
                return item
            })
        }

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 200)

    // when variant sku changes
    const handleVariantSKUChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        if (inpValue) {
            ev.target.parentElement.classList.remove("empty-field")

            // creating main combination array copy
            let COPY_productCombinations = [...productCombinations]

            // generating values
            const newCombinationArray = COPY_productCombinations.map(item => {
                if (item.id === id) {
                    // returning array with changed values
                    return {
                        ...item,
                        sku: inpValue, // changing value
                    }
                }
                return item
            })

            // setting combinatins values
            setProductCombinations(newCombinationArray)
        } else {
            ev.target.parentElement.classList.add("empty-field")
            console.log("cann not be empty ");
        }
    }, 300)

    // when variant cost changes
    const handleVariantCostChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    cost_price: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant price changes
    const handleVariantPriceChange = debounce((ev, id) => {
        let inpValue = ev.target.value
        if (inpValue) {
            ev.target.parentElement.classList.remove("empty-field")
            // creating main combination array copy
            let COPY_productCombinations = [...productCombinations]

            // generating values
            const newCombinationArray = COPY_productCombinations.map(item => {
                if (item.id === id) {
                    // returning array with changed values
                    return {
                        ...item,
                        price: inpValue, // changing value
                    }
                }
                return item
            })

            // setting combinatins values
            setProductCombinations(newCombinationArray)
        } else {
            ev.target.parentElement.classList.add("empty-field")
        }
    }, 300)

    // when variant stock changes
    const handleVariantStockChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    stock: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant image changes
    const handleVariantImgChange = (ev, id) => {
        let inpValue = ev.target.value;
        let file = ev.target.files[0];

        // initializing FileReader
        let reader = new FileReader();

        // reading data from the file
        reader.readAsDataURL(file);

        // on load
        reader.onload = function () {
            // creating main combination array copy
            let COPY_productCombinations = [...productCombinations]

            // generating values
            const newCombinationArray = COPY_productCombinations.map(item => {
                if (item.id === id) {
                    // returning array with changed values
                    return {
                        ...item,
                        variation_image: {
                            value: inpValue,
                            src: reader.result
                        }, // changing value
                    }
                }
                return item
            })

            // setting combinatins values
            setProductCombinations(newCombinationArray)
        };

        // on error
        reader.onerror = function () {
            console.log("error while getting file info ", reader.error);
        };
    }

    // when variant weight changes
    const handleVariantWeightChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    weight: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant length changes
    const handleVariantLengthChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    length: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant width changes
    const handleVariantWidthChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    width: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant height changes
    const handleVariantHeightChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    height: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant upc changes
    const handleVariantUPCChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    upc: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // when variant description changes
    const handleVariantDescriptionChange = debounce((ev, id) => {
        let inpValue = ev.target.value

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    description: inpValue, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)
    }, 300)

    // edit variant image delete
    const handleDeleteVariantImageChange = (ev, id) => {
        ev.preventDefault()

        // creating main combination array copy
        let COPY_productCombinations = [...productCombinations]

        // generating values
        const newCombinationArray = COPY_productCombinations.map(item => {
            if (item.id === id) {
                // returning array with changed values
                return {
                    ...item,
                    variation_image: {}, // changing value
                }
            }
            return item
        })

        // setting combinatins values
        setProductCombinations(newCombinationArray)

        // closing the modal    
        setEditVariantImgModalVisibility(false)
    }

    // open the edit variant image modal
    const handleEditVariantMoreDetailsModalOpen = (ev, id) => {
        ev.preventDefault()

        let data = productCombinations.filter(item => item.id === id)

        if (id) {
            // setting the modal data
            setVariantSelectedId(id)

            setVariantSelectedItemForMoreDetails(data)
        }

        // opening the modal
        setEditVariantMoreDetailsVisibility(true)
    }

    // close the edit variant image modal
    const handleEditVariantMoreDetailsModalClose = () => {
        // closing the modal    
        setEditVariantMoreDetailsVisibility(false)
    }

    // open the edit variant image modal
    const handleEditVariantImgModalOpen = (data, largeImgSrc) => {
        if (data && largeImgSrc) {
            // setting the modal data
            setVariantSelectedToBeEdit({
                ...data,
                largeImgSrc
            })
        }

        // opening the modal    
        setEditVariantImgModalVisibility(true)
    }

    // close the edit variant image modal
    const handleEditVariantImgModalClose = () => {
        // closing the modal    
        setEditVariantImgModalVisibility(false)
    }

    // disable variant
    const handleDisableVariant = (ev, id) => {
        ev.preventDefault()

        if (id) {
            setDisabledVariantList([
                ...disabledVariantList,
                id
            ])
        }
    }

    // enable variant
    const handleEnableVariant = (ev, id) => {
        ev.preventDefault()

        if (id) {
            const updatedList = disabledVariantList.filter(item => item !== id)
            setDisabledVariantList(updatedList)
        }
    }

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* btns */}
                    <div className="btns d-flex align-items-center mb-3">
                        {/* <button className="st-btn st-btn-white-gray-outlined st-btn-sm d-flex align-items-center text-capitalize me-3">
                            <span className="round-feather-icon-outlined hoverable d-inline-flex align-items-center justify-content-center me-2">
                                <FeatherIcon
                                    icon="plus"
                                    size="10"
                                    className="icon cursor-pointer" />
                            </span>
                            <span>new variation</span>
                        </button> */}

                        <p className="st-fw-600 st-text-color">
                            Variants
                            <span className="st-text-primary">
                                {(productCombinations?.length) ? ` (${productCombinations.length} combinations)` : " (0)"}
                            </span>
                        </p>
                    </div>

                    <div className="products-variants-table">
                        {
                            (productCombinations?.length) ? (
                                <div className="pvt-table table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th width="50">
                                                    Enable
                                                </th>
                                                <th width="60">
                                                    Image
                                                </th>
                                                <th>
                                                    Variant
                                                </th>
                                                <th width="120">
                                                    SKU
                                                </th>
                                                <th width="80">
                                                    Weight
                                                </th>
                                                <th width="80">
                                                    Cost
                                                </th>
                                                <th width="80">
                                                    Price
                                                </th>
                                                <th width="80">
                                                    Stock
                                                </th>
                                                <th width="45"></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                console.log("productCombinations ", productCombinations)
                                            }
                                            {
                                                productCombinations.map((item, index) => (
                                                    <tr data-key={item.id} key={item.id} className={`${disabledVariantList.find(ele => ele === item.id) ? "variant-disabled" : ""}`}>
                                                        {/* column__Enable */}
                                                        <td className="column__Enable text-center">
                                                            <label className="st-checkbox st-checkbox-primary d-inline-flex cursor-pointer">
                                                                <input type="checkbox" className="d-none all-checkboxes-selector-checkbox"
                                                                    defaultChecked={item.status ? true : false}
                                                                    onChange={ev => handleVariantEnableChange(ev, item.id)}
                                                                />
                                                                <span className="box d-flex align-items-center justify-content-center border" style={{ height: 22, width: 22 }}>
                                                                    <FeatherIcon
                                                                        icon="check"
                                                                        size="14"
                                                                        className="icon" />
                                                                </span>
                                                            </label>
                                                        </td>

                                                        {/* column__Image */}
                                                        <td className="column__Image no-pad">
                                                            {
                                                                // if img exists
                                                                (productCombinationsImages[item.sku]?.small?.length) ? (
                                                                    <div
                                                                        className="img-container d-flex align-items-center justify-content-center cursor-pointer"
                                                                        title="Change Image"
                                                                        onClick={() => handleEditVariantImgModalOpen(item, productCombinationsImages[item.sku].medium[0])}
                                                                    >
                                                                        <img src={productCombinationsImages[item.sku].small[0]} alt="product img" className="img-fluid img-fluid-height" />
                                                                    </div>
                                                                ) : (
                                                                    <label className="img-container d-flex align-items-center justify-content-center cursor-pointer" title="Add Image">
                                                                        <input
                                                                            type="file"
                                                                            accept="image/png, image/gif, image/jpeg"
                                                                            hidden
                                                                            onChange={ev => handleVariantImgChange(ev, item.id)}
                                                                        />
                                                                        <FeatherIcon
                                                                            icon="camera"
                                                                            size="16"
                                                                            className="icon"
                                                                        />
                                                                    </label>
                                                                )
                                                            }
                                                        </td>

                                                        {/* column__Variant */}
                                                        <td className="column__Variant text-capitalize" title={item.variant}>
                                                            {
                                                                item?.variant?.length && item.variant.split(',').map((item, index) => (
                                                                    <p key={index}>{item}</p>
                                                                ))
                                                            }
                                                        </td>

                                                        {/* column__Sku */}
                                                        <td className="column__Sku no-pad has-input">
                                                            <input type="text" defaultValue={`${item.sku ? item.sku : ""}`}
                                                                placeholder={formik.getFieldProps("SKU").value}
                                                                onChange={ev => handleVariantSKUChange(ev, item.id)}
                                                            />
                                                        </td>

                                                        {/* column__Weight */}
                                                        <td className="column__Weight no-pad has-input">
                                                            <input type="number" min="0"
                                                                defaultValue={`${item.weight ?? ""}`}
                                                                placeholder={formik.getFieldProps("weight").value}
                                                                onChange={ev => handleVariantWeightChange(ev, item.id)}
                                                            />
                                                        </td>

                                                        {/* column__Cost */}
                                                        <td className="column__Cost no-pad has-input">
                                                            <input type="number" min="0"
                                                                defaultValue={item.cost_price}
                                                                placeholder={formik.getFieldProps("costPrice").value}
                                                                onChange={ev => handleVariantCostChange(ev, item.id)}
                                                            />
                                                        </td>

                                                        {/* column__Price */}
                                                        <td className="column__Price no-pad has-input">
                                                            <input type="number" min="0"
                                                                defaultValue={item.price}
                                                                placeholder={formik.getFieldProps("price").value}
                                                                onChange={ev => handleVariantPriceChange(ev, item.id)}
                                                            />
                                                        </td>

                                                        {/* column__Stock */}
                                                        <td className="column__Stock no-pad has-input">
                                                            <input type="number" min="0" defaultValue={item.stock}
                                                                placeholder={formik.getFieldProps("stock").value}
                                                                onChange={ev => handleVariantStockChange(ev, item.id)}
                                                            />
                                                        </td>

                                                        {/* column__actions */}
                                                        <td className="column__actions">
                                                            <div className="d-flex">
                                                                {/* edit */}
                                                                <button
                                                                    className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                                    onClick={ev => handleEditVariantMoreDetailsModalOpen(ev, item.id)}
                                                                >
                                                                    <FeatherIcon
                                                                        icon="edit-2"
                                                                        size="15"
                                                                        className="icon" />
                                                                </button>

                                                                {/* edit */}
                                                                {
                                                                    disabledVariantList.find(ele => ele === item.id) ? (
                                                                        <button
                                                                            className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                                            onClick={ev => handleEnableVariant(ev, item.id)}
                                                                        >
                                                                            <FeatherIcon
                                                                                icon="eye"
                                                                                size="15"
                                                                                className="icon" />
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="st-round-btn st-btn-secondary st-btn-xs d-flex align-items-center justify-content-center me-2"
                                                                            onClick={ev => handleDisableVariant(ev, item.id)}
                                                                        >
                                                                            <FeatherIcon
                                                                                icon="eye-off"
                                                                                size="15"
                                                                                className="icon" />
                                                                        </button>
                                                                    )
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="page-border-box2">
                                    <div className="pbb2-inner text-center bg-white">
                                        <p>no variant has been added yet</p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>

            {/* modal | edit variant picture */}
            <Modal show={editVariantImgModalVisibility} onHide={handleEditVariantImgModalClose} centered>
                <Modal.Body className="st-modal">
                    <EditVariantImageModal
                        closeModal={handleEditVariantImgModalClose}
                        modalData={variantSelectedToBeEdit}

                        handleDeleteVariantImageChange={(ev, id) => handleDeleteVariantImageChange(ev, id)}
                    />
                </Modal.Body>
            </Modal>

            {/* modal | edit more variant details */}
            <Modal show={editVariantMoreDetailsVisibility} onHide={handleEditVariantMoreDetailsModalClose}>
                <Modal.Body className="st-modal">
                    <EditVariantMoreDetailsModal
                        closeModal={handleEditVariantMoreDetailsModalClose}
                        modalData={variantSelectedItemForMoreDetails}

                        variantSelectedId={variantSelectedId}

                        handleVariantLengthChange={(ev, id) => handleVariantLengthChange(ev, id)}
                        handleVariantWidthChange={(ev, id) => handleVariantWidthChange(ev, id)}
                        handleVariantHeightChange={(ev, id) => handleVariantHeightChange(ev, id)}
                        handleVariantUPCChange={(ev, id) => handleVariantUPCChange(ev, id)}
                        handleVariantDescriptionChange={(ev, id) => handleVariantDescriptionChange(ev, id)}
                    />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}
